import {
  Component,
  HostBinding,
  OnInit,
  ViewChild,
} from "@angular/core";
import { NGXLogger } from "ngx-logger";
import { ConfirmationService, MenuItem, Message, MessageService } from "primeng/api";


import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";

import { Router } from "@angular/router";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { TipoIntervento } from "src/app/models/tipoIntervento.model";
import { TipiInterventoService } from "src/app/services/tipiIntervento.service";
import { CreaTipoInterventoComponent } from "./crea/crea-tipo_intervento";
import { ModificaTipoInterventoComponent } from "./modifica/modifica-tipo_intervento";

declare const CSVBoxImporter: any;
@Component({
  selector: "tipi_intervento",
  templateUrl: "./tipi_intervento.component.html",
  styleUrls: ["./tipi_intervento.component.css"],
  providers: [DialogService, ConfirmationService],
})
export class TipiInterventoComponent implements OnInit {
  isLoadingResults = false;
  resultsLength = 0;
  tipiIntervento: TipoIntervento[] = [];

  public isAdmin:boolean = false;
    dialogConfig;

  @ViewChild("tipiInterventoDT", { static: true }) tipiInterventoDT: any;

  @HostBinding("class.mobile") isMobile: boolean;

  msgs: Message[] = [];
  ref: DynamicDialogRef;

  constructor(
    private logger: NGXLogger,
    public dialogService: DialogService,
    public firestore: AngularFirestore,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private tipoInterventoService: TipiInterventoService,


  ) {
    this.detectDevice();
    this.dialogConfig = {
      height: "600px",
      width: "600px",
      disableClose: true,
      data: {},
    };
  }
  detectDevice() {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    this.isMobile = isMobile;
  }
  ngOnInit(): void {
    /* if(localStorage.getItem("ruolo") && localStorage.getItem("ruolo")==='ADMIN'){
      this.isAdmin = true;
    } */
    this.loadTipiIntervento();
  }

  ngAfterViewInit() {}

  filtraPerNome(event: any){
    this.tipiInterventoDT.filterGlobal(event.target.value, 'contains')
  }



  loadTipiIntervento() {
    this.isLoadingResults = true;
    this.tipoInterventoService.get().subscribe(tipiInterventoFromDB =>{
      this.tipiIntervento = tipiInterventoFromDB;
      this.isLoadingResults = false;
    });
  }

  getAreaCompetenzaBackgroundColor(areaCompetenza:string){
    if (areaCompetenza === "PUBBLICA") {
      return "#095b7b";
    }else if (areaCompetenza === "VOTIVA") {
      return "#3d14c2";
    }else if (areaCompetenza === "CONDIZIONAMENTO - RISCALDAMENTO") {
      return "#227749";
    }else if (areaCompetenza === "IDRAULICA") {
      return "#777C9D";
    }else if (areaCompetenza === "ALTRO") {
      return "#4E7495";
    }
    return "";
  }
  getAreaCompetenzaColor(areaCompetenza:string){
    if (areaCompetenza === "PUBBLICA") {
      return "#ffffff";
    }else if (areaCompetenza === "VOTIVA") {
      return "#ffffff";
    }else if (areaCompetenza === "CONDIZIONAMENTO - RISCALDAMENTO") {
      return "#ffffff";
    }else if (areaCompetenza === "IDRAULICA") {
      return "#ffffff";
    }else if (areaCompetenza === "ALTRO") {
      return "#ffffff";
    }

    return "";
  }

  openEliminaTipoIntervento(tipoIntervento:TipoIntervento){

  }

  openCreaTipoIntervento(){
     this.ref = this.dialogService.open(CreaTipoInterventoComponent, {
      data: {

      },
      header: 'Crea tipo di intervento',
      width: this.isMobile?'90%':'40%',
      height: this.isMobile?'90%':'80%',
      baseZIndex: 10000,
      closable:true,
      draggable:false,
  });
  this.ref.onClose.subscribe(confirmNewUtente => {
    if(confirmNewUtente && confirmNewUtente.success){
      this.messageService.add({
        severity: "success",
        summary: "",
        detail: "Tipo di intervento creato con successo!", life:10000
      });
      this.loadTipiIntervento();
    }
  });
  }

  openModificaTipoInterventoDialog(tipoIntervento:TipoIntervento){
      this.ref = this.dialogService.open(ModificaTipoInterventoComponent, {
        data: {
          tipoIntervento : tipoIntervento
        },
        header: 'Modifica tipo di intervento',
        width: this.isMobile?'90%':'40%',
        height: this.isMobile?'90%':'80%',
        baseZIndex: 10000,
        closable:true,
        draggable:false,
    });
    this.ref.onClose.subscribe(confirmNewUtente => {
      if(confirmNewUtente && confirmNewUtente.success){
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Tipo di intervento modificato con successo!", life:10000
        });
        this.loadTipiIntervento();
      }
    });
  }

  openEliminaTipoInterventoDialog(tipoIntervento:TipoIntervento){
    this.confirmationService.confirm({
      message: `Confermi l\'eliminazione del tipo di intervento: <b>${tipoIntervento.label.toUpperCase()}</b>?`,
      header: "Eliminazione Tipo Intervento",
      icon: "pi pi-eraser",
      acceptLabel: "CONFERMA",
      acceptButtonStyleClass: "p-button-success",
      rejectLabel: "ANNULLA",
      rejectButtonStyleClass: "p-button-warning",
      accept: () => {
        this.tipoInterventoService.elimina(tipoIntervento.id.toString()).subscribe({
          next: (v) => {},
          error: (e) => {
            this.messageService.add({
              severity: "info",
              summary: "Errore",
              detail: "Errore in fase di eliminazione Tipo Intervento", life:10000
            });
          },
          complete: () => {
            this.messageService.add({
              severity: "success",
              summary: "",
              detail: "Tipo Intervento eliminata", life:10000
            });
            this.loadTipiIntervento();
          },
        });
      },
      reject: () => {},
    });
  }



}
